import { useCallback, useEffect } from "react";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { create } from "zustand";

const STORAGE_KEY = "house_pick_distance_unit";

const useHousePickDistanceUnitStore = create((set) => ({
  unit: "mi",
  setUnitState: (unit) => set({ unit }),
}));

/**
 * Client-only preference for House Pick result distance display (miles vs km).
 * Uses a shared store so Profile settings and House Pick results stay in sync.
 */
export function useHousePickDistanceUnit() {
  const unit = useHousePickDistanceUnitStore((s) => s.unit);
  const setUnitState = useHousePickDistanceUnitStore((s) => s.setUnitState);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const stored = await AsyncStorage.getItem(STORAGE_KEY);
        if (!cancelled && (stored === "mi" || stored === "km")) {
          setUnitState(stored);
        }
      } catch (e) {
        console.error("Error loading house pick distance unit", e);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [setUnitState]);

  const setUnit = useCallback(
    async (next) => {
      if (next !== "mi" && next !== "km") return;
      setUnitState(next);
      try {
        await AsyncStorage.setItem(STORAGE_KEY, next);
      } catch (e) {
        console.error("Error saving house pick distance unit", e);
      }
    },
    [setUnitState]
  );

  return { unit, setUnit };
}
